import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getIdToken } from "../../auth";
import chalk from "chalk";
import logSymbols from "log-symbols";
import { BASE_URL_ENDPOINT } from '../../config/env';

import {
  IRepositoryss,
  IResult,
  IPaging,
  INewRepository,
  IAccessRepository,
} from "../../types/Repositorys";
import { IRepositoryFilter } from "../../types/RepositoryFilters";
import {
  getHttpErrorCategory,
  isHttpCodeSuccess,
  findHttpStatusInfo,
} from "../../../src/Helpers/Http.commons";

interface IState {
  paging: null | IPaging;
  result: IRepositoryss | any;
  // resultsearch: IRepositoryss | any,
  results: IResult[] | any;
  resultado: IRepositoryFilter | any;
  repository: INewRepository | null;
  resultss: IAccessRepository | any;
  error: null | any;
  statusCode: number | null | undefined;
  response: Object | undefined;
}

const initialState: IState = {
  paging: null,
  // result: '',
  resultado: {},
  result: "",
  results: [],
  resultss: null,
  repository: null,
  statusCode: null,
  response: undefined,
  error: null,
};

export const fetchPullRepositorys = createAsyncThunk(
  "fetchPullRepositorys",
  async (params: { Page: number; Take: number }) => {
    try {
      const token = getIdToken();
      const { Page, Take } = params;
      const response = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/repository?page=${Page}&take=${Take}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return await response.json();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const fetchMyRepositories = createAsyncThunk(
  "fetchMyRepositories",
  async (params: { Page: number; Take: number }) => {
    try {
      const token = getIdToken();
      const { Page, Take } = params;
      const response = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/repository/my-repositories?page=${Page}&take=${Take}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return await response.json();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const fetchSearchRepositorys = createAsyncThunk(
  "fetchSearchRepositorys",
  async (name: string): Promise<any> => {
    try {
      const token = getIdToken();
      const response = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/repository?page=1&take=100&name=${name}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return await response.json();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const fetchUploadRepository = createAsyncThunk(
  "fetchUploadRepository",
  async (formObject: any) => {
    try {
      const token = getIdToken();
      const requestData = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-request`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formObject),
        }
      );

      if (isHttpCodeSuccess(requestData.status)) {
        return {
          statusCode: requestData.status,
          response: requestData,
          error: null,
        };
      } else {
        const httpData: any = findHttpStatusInfo(requestData.status);
        const { message, title } = httpData;

        return {
          statusCode: requestData.status,
          response: title,
          error: message,
        };
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

export const fetchRepositoryAccess = createAsyncThunk(
  "fetchRepositoryAccess",
  async ({ formObject }: { formObject: any }) => {
    try {
      const token = getIdToken();
      const repositoryName = sessionStorage.getItem("repositoryName");
      const requestData = await fetch(
        `${BASE_URL_ENDPOINT}/management-ctx/api/v2/repository-access`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "repository-name": `${repositoryName}`,
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(formObject),
        }
      );

      if (isHttpCodeSuccess(requestData.status)) {
        return {
          statusCode: requestData.status,
          response: requestData,
          error: null,
        };
      } else {
        const httpData: any = findHttpStatusInfo(requestData.status);
        const { message, title } = httpData;

        return {
          statusCode: requestData.status,
          response: title,
          error: message,
        };
      }
    } catch (error) {
      console.error(error);
      throw new Error("Error al procesar la solicitud");
    }
  }
);

export const fetchPullRepositorysById = createAsyncThunk(
  "fetchPullRepositorysById",
  async function fetchRepository(repositoryId: string): Promise<any> {
    try {
      const token = getIdToken();
      const response = await fetch(
        `${BASE_URL_ENDPOINT}/repository-ctx/api/v2/repository/${repositoryId}`,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization:`Bearer ${token}`,
          },
        }
      );
      console.log("este es el log del repositorybyid:", response);
      return await response.json();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

const RepositorysSlice = createSlice({
  name: "repositorysSlice",
  initialState,
  reducers: {},

  extraReducers(builder) {
    builder
      .addCase(fetchPullRepositorys.fulfilled, (state, action) => {
        state.paging = action.payload.paging;
        // console.log("state-paging:", state.paging);
        sessionStorage.setItem('total-pages', state.paging!.pages.toString());
        state.result = action.payload.result;
        // console.log("state-result-listado-repositorio****:", state.result);
        state.error = null;
      })
      .addCase(fetchPullRepositorys.rejected, (state, action) => {
        state.error = action.payload;
      });

      builder
      .addCase(fetchMyRepositories.fulfilled, (state, action) => {
        state.paging = action.payload.paging;
        // console.log("state-paging:", state.paging);
        sessionStorage.setItem('total-pages', state.paging!.pages.toString());
        state.result = action.payload.result;
        // console.log("state-result-listado-repositorio****:", state.result);
        state.error = null;
      })
      .addCase(fetchMyRepositories.rejected, (state, action) => {
        state.error = action.payload;
      }); 

    builder
      .addCase(fetchUploadRepository.pending, (state) => {
        state.statusCode = null;
        state.response = {};
        state.error = null;
      })
      .addCase(fetchUploadRepository.fulfilled, (state, action) => {
        const { statusCode, response, error } = action.payload;

        state.statusCode = statusCode;
        state.response = response;
        state.error = error;
      })
      .addCase(fetchUploadRepository.rejected, (state, action) => {
        state.statusCode = 500;
        state.response = "Error en el servidor, testing",
        state.error = "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde.";
      });

    builder
      .addCase(fetchSearchRepositorys.fulfilled, (state, action) => {
        state.paging = action.payload.paging;
        console.log("state-paging:", state.paging);
        state.result = action.payload.result;
        console.log("state-result-search-repositorio****:", state.result);
        state.error = null;
      })
      .addCase(fetchSearchRepositorys.rejected, (state, action) => {
        state.error = action.payload;
      });

    builder
      .addCase(fetchRepositoryAccess.pending, (state) => {
        state.statusCode = null;
        state.response = {};
        state.error = null;
      })
      .addCase(fetchRepositoryAccess.fulfilled, (state, action) => {
        const { statusCode, response, error } = action.payload;

        state.statusCode = statusCode;
        state.response = response;
        state.error = error;
      })
      .addCase(fetchRepositoryAccess.rejected, (state, action) => {
        state.statusCode = 500;
        state.response = "Error en el servidor, testing",
        state.error = "Hubo un error al procesar su solicitud. Por favor, inténtelo de nuevo más tarde.";
      });

    builder
      .addCase(fetchPullRepositorysById.fulfilled, (state, action) => {
        state.resultado = action.payload;
        console.log("este es el resultado del repositorybyid:", state.resultado);
        state.error = null;
      })
      .addCase(fetchPullRepositorysById.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export default RepositorysSlice.reducer;
